import gql from 'graphql-tag';

export const saveViewMutation = gql`
  mutation saveView($input: UserSaveViewInput!) {
    saveView(input: $input) {
      status
      userViewState
    }
  }
`;
